import { useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { UserHealthcareDomain } from "@/types/user";

export interface UpdateUserHealthcareDomainData {
  healthcare_domain_id: UserHealthcareDomain["healthcare_domain"]["id"];
  years_of_experience?: UserHealthcareDomain["years_of_experience"];
  remove_healthcare_domain?: boolean;
}

export interface UpdateUserHealthcareDomainResponse {
  success: boolean;
  message: string;
  healthcare_domain?: {
    id: UserHealthcareDomain["id"];
    user: UserHealthcareDomain["user"];
    healthcare_domain: UserHealthcareDomain["healthcare_domain"];
    years_of_experience: UserHealthcareDomain["years_of_experience"];
  };
}

export const useUpdateUserHealthcareDomain = () => {
  const [data, setData] = useState<UpdateUserHealthcareDomainResponse | null>(
    null,
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const updateUserHealthcareDomain = async (
    formData: UpdateUserHealthcareDomainData,
  ) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      setError("Not authenticated.");
      setLoading(false);
      return;
    }

    try {
      const response =
        await axiosInstance.post<UpdateUserHealthcareDomainResponse>(
          "users/users/update_user_healthcare_domain/",
          formData,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          },
        );
      setData(response.data);

      if (response.data.success) {
        setSuccess(true);
      }
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, success, updateUserHealthcareDomain };
};
